import { Typography } from "@mui/material";
import * as Styled from "./Error.styles";

export const ErrorPage = () => {
  return (
    <>
      <Styled.Title variant="h5">Error</Styled.Title>
      <Typography variant="subtitle1" color="text.secondary" sx={{ fontWeight: 500 }}>
        Your order has been failed. Please try again later.
      </Typography>
    </>
  );
};
